import {
  BridgeNoticeSection,
  CautionSection,
  ComparisonQnaSection,
  FloatingCtaBar,
  FooterNotesSection,
  HeroSection,
  PriceSection,
  ProsConsSection,
  SoldOutOverlay,
  SpecSection,
} from './components'
import { LandingContainer, LandingScroll } from './styles'

interface LandingStepProps {
  onCtaClick: () => void
  /** CTA 검증 진행 중 — 중복 클릭 방지용 */
  isCtaPending?: boolean
  /** 재고 소진 — 딤 오버레이 노출 + CTA 비활성·안내 문구 */
  soldOut?: boolean
}

export function LandingStep({ onCtaClick, isCtaPending, soldOut = false }: LandingStepProps) {
  return (
    <LandingContainer>
      <LandingScroll>
        <HeroSection />
        <ProsConsSection />
        <BridgeNoticeSection />
        <SpecSection />
        <ComparisonQnaSection />
        <PriceSection />
        <CautionSection />
        <FooterNotesSection />
      </LandingScroll>
      {soldOut && <SoldOutOverlay />}
      <FloatingCtaBar
        onClick={onCtaClick}
        loading={isCtaPending}
        soldOut={soldOut}
      />
    </LandingContainer>
  )
}
